
  <div class="p-g-12 p-md-12 p-lg-12" style="height: 400px;">
    <div id="driverLocationMap" class="map"></div>
  </div>

